import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

const ToastContext = createContext({
  showToast: () => {},
  showErrorToast: () => {},
});

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const removeTimersRef = useRef(new Map());

  const showToast = useCallback((message, options = {}) => {
    if (!message) return;
    const { type = 'info', timeout = 2500 } = options;
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    setToasts((prev) => [{ id, message, type, leaving: false }, ...prev]);
    const removeTimer = window.setTimeout(() => {
      setToasts((prev) => prev.map((toast) => (toast.id === id ? { ...toast, leaving: true } : toast)));
      const finalizeTimer = window.setTimeout(() => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
        removeTimersRef.current.delete(id);
      }, 440);
      removeTimersRef.current.set(id, finalizeTimer);
    }, timeout);
    removeTimersRef.current.set(id, removeTimer);
  }, []);

  const showErrorToast = useCallback((message, options = {}) => {
    showToast(message, { ...options, type: 'error' });
  }, [showToast]);

  const value = useMemo(() => ({
    showToast,
    showErrorToast,
  }), [showToast, showErrorToast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="toast-alert-stack">
        {toasts.map((toast, index) => (
          <div
            key={toast.id}
            className={`toast-alert toast-alert--global${toast.type === 'error' ? ' toast-alert--error' : ''}${toast.leaving ? ' toast-alert--leaving' : ''}`}
            style={{ bottom: `${index * 70}px` }}
          >
            <p>{toast.message}</p>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
